module.exports = __webpack_public_path__ + "Spaces.72edc6af225d8ac51164a846362d98af.hashedasset.svg";